class CollectionNavigation {
    constructor() {
        this.sectionLinks = document.querySelectorAll('.section-link');
        this.desktopSections = document.querySelectorAll('.collection-grid');
        this.heroSections = document.querySelectorAll('.collection-hero');
        this.navContainer = document.querySelector('.collection-navigation');

        this.init();
    }

    init() {
        const urlParts = window.location.pathname.split('/').filter(Boolean);
        const collectionHandle = urlParts[urlParts.indexOf('collections') + 1];

        if (collectionHandle) {
            this.showCollectionByHandle(collectionHandle);
        } else if (this.sectionLinks.length > 0) {
            const firstHandle = this.sectionLinks[0].getAttribute('data-collection-handle');
            this.showCollectionByHandle(firstHandle);
        }

        this.attachLinkEventListeners();
        this.attachPopStateListener();
    }

    showCollectionByHandle(handle) {
        this.desktopSections.forEach(section => (section.style.display = 'none'));
        this.heroSections.forEach(section => (section.style.display = 'none'));
        this.sectionLinks.forEach(link => link.classList.remove('active'));

        const matchingLink = Array.from(this.sectionLinks).find(
            link => link.getAttribute('data-collection-handle') === handle
        );

        if (matchingLink) {
            const sectionId = matchingLink.getAttribute('data-section-id');

            document.querySelectorAll(`#${sectionId}`).forEach(section => {
                section.style.display = 'grid';
                section.classList.add('fade-in');
            });

            document.querySelectorAll(`.collection-hero[data-section-id="${sectionId}"]`).forEach(section => {
                section.style.display = 'block';
                section.classList.add('fade-in');
            });

            matchingLink.classList.add('active');

            const linkPosition =
                matchingLink.getBoundingClientRect().left - this.navContainer.getBoundingClientRect().left;
            this.navContainer.scrollTo({
                left: this.navContainer.scrollLeft + linkPosition - 20,
                behavior: 'smooth',
            });
        }
    }

    attachLinkEventListeners() {
        this.sectionLinks.forEach(link => {
            link.addEventListener('click', event => {
                event.preventDefault();

                const collectionHandle = link.getAttribute('data-collection-handle');
                if (collectionHandle) {
                    const newUrl = `${window.location.origin}/collections/${collectionHandle}`;
                    history.pushState(null, '', newUrl);
                    this.showCollectionByHandle(collectionHandle);
                }
            });
        });
    }

    attachPopStateListener() {
        window.addEventListener('popstate', () => {
            const urlParts = window.location.pathname.split('/').filter(Boolean);
            const collectionHandle = urlParts[urlParts.indexOf('collections') + 1];
            if (collectionHandle) {
                this.showCollectionByHandle(collectionHandle);
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new CollectionNavigation();
});
